import { render } from "./SettingsTabMedTypePresets.vue?vue&type=template&id=81225da0&scoped=true"
import script from "./SettingsTabMedTypePresets.vue?vue&type=script&lang=js"
export * from "./SettingsTabMedTypePresets.vue?vue&type=script&lang=js"

import "./SettingsTabMedTypePresets.vue?vue&type=style&index=0&id=81225da0&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81225da0"]])

export default __exports__